<template>
  <div class="timeline-item">
    <div v-if="timer" class="timer">
      <div v-if="timer.date" class="timer-date">{{ timer.date || "-" }}</div>
      <div v-if="timer.time" class="timer-time">{{ timer.time || "-" }}</div>
    </div>
    <div class="item-content">
      <div v-if="showLine" class="timeline-line"></div>
      <div class="timeline-item-point"></div>
      <div v-if="title" class="timeline-item-title">{{ title }}</div>
      <div class="timeline-item-content">{{ message || "-" }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vx-timeline",
  props: {
    showLine: {
      type: Boolean,
      default: true,
    },
    timer: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss">
.timeline-item {
  display: flex;
  .timer {
    width: 20%;
    padding-right: 18px;
    text-align: right;
    font-size: 12px;
    .timer-time {
    }
  }
  .item-content {
    width: 80%;
    min-height: 50px;
    padding: 0 1.5rem 1rem 1.5rem;
    position: relative;
    .timeline-line {
      position: absolute;
      top: 5px;
      left: 0;
      width: 1px;
      height: 100%;
      background: #ebe9f1;
    }
    .timeline-item-point {
      position: absolute;
      width: 12px;
      height: 12px;
      top: 5px;
      z-index: 1;
      left: -6px;
      border-radius: 50%;
      background-color: rgb(64, 144, 255);
    }
    .timeline-item-title {
      line-height: 24px;
    }
    .timeline-item-content {
      font-size: 12px;
    }
  }
}
</style>
